import { ICoordinates } from "../../types/addresTypes";
import { CurrentLocationTypes } from "../types/currentLocation";
import { ReturnActionType } from "../types/return-type";

export const setCurrentLocation = (payload: ICoordinates): ReturnActionType => ({
  type: CurrentLocationTypes.SET_CURRENT_LOCATION,
  payload,
});
